export default __webpack_public_path__ + "static/tower-of-babel-05d1c4ae194d1c89d88ce46ca7e32f6c.png";